import { useEffect, useState } from "react";
import { getCurrentPick, HIGHLIGHT_TTL_MS } from "@/lib/mochiPick";

// Mochi's "what should I do?" pick.
// Holds the current suggestion (task_id + created_at + message) so the app
// can render the golden highlight + 🍡 badge on the matched row, and
// special-toast if the user completes it within 30 minutes. Persisted in
// localStorage by lib/mochiPick.js so it survives reloads (10-min TTL).
export function useMochiPick() {
    const [mochiPick, setMochiPick] = useState(() => getCurrentPick());
    useEffect(() => {
        if (!mochiPick) return undefined;
        const remaining = HIGHLIGHT_TTL_MS - (Date.now() - mochiPick.created_at);
        if (remaining <= 0) {
            setMochiPick(null);
            return undefined;
        }
        const t = setTimeout(() => setMochiPick(null), remaining);
        return () => clearTimeout(t);
    }, [mochiPick]);
    return [mochiPick, setMochiPick];
}
